module.exports = __webpack_public_path__ + "static/media/loading.8d98de54.png";